Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _airbnbPropTypes = require('airbnb-prop-types');

var _lineTypes = require('../constants/lineTypes');

var _lineTypes2 = _interopRequireDefault(_lineTypes);

var _BaseRow = require('../private/BaseRow');

var _BaseRow2 = _interopRequireDefault(_BaseRow);

var _HeadingSection = require('./HeadingSection');

var _HeadingSection2 = _interopRequireDefault(_HeadingSection);

var _Title = require('./Title');

var _Title2 = _interopRequireDefault(_Title);

var _textlike = require('../utils/propTypes/textlike');

var _textlike2 = _interopRequireDefault(_textlike);

var _withStyles = require('../themes/withStyles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
  children: _propTypes2['default'].node,
  title: _textlike2['default']
}));

var defaultProps = {
  title: null
};

function Panel(_ref) {
  var css = _ref.css,
      title = _ref.title,
      children = _ref.children,
      styles = _ref.styles;

  return _react2['default'].createElement(
    'div',
    css(styles.container),
    title && _react2['default'].createElement(
      _HeadingSection2['default'],
      null,
      _react2['default'].createElement(
        _BaseRow2['default'],
        { baseline: _lineTypes2['default'].NONE },
        _react2['default'].createElement(
          _Title2['default'],
          { level: 2 },
          title
        )
      ),
      children
    ),
    !title && children
  );
}

Panel.componentCategory = 'Core';
Panel.displayName = 'Panel';
Panel.propTypes = propTypes;
Panel.defaultProps = defaultProps;

exports['default'] = (0, _withStyles.withStyles)(function (_ref2) {
  var color = _ref2.color,
      unit = _ref2.unit;
  return {
    container: {
      paddingLeft: unit * 3,
      paddingRight: unit * 3,
      margin: 0,
      border: '1px solid ' + String(color.panelBorder),
      backgroundColor: color.white
    }
  };
})(Panel);


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/Panel.js
// module id = 143
// module chunks = 923280921217 19843951674672